// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"AddPost_formContainer__3UCzg","postTypes":"AddPost_postTypes__2KzVn","viewPdf":"AddPost_viewPdf__3Nl0b","files":"AddPost_files__2G1Oj"};